import { useEffect, useState } from 'react';
import './ColorAndPenPicker.less';
import ColorPicker from '@rc-component/color-picker';
import '@rc-component/color-picker/assets/index.css';
import { Slider } from 'antd';
import toast from 'react-hot-toast';
import { adjustBrushSize } from '@/utils/unityTool';
import { info } from '@/utils/message';

export default function ColorAndPenPicker({
  onSizeChange,
  onColorChange,
  showColor,
  size,
  sendMessage,
}) {
  const [sizeValue, setSizeValue] = useState(size || 0.2);
  const [eyeDropperColor, setEyeDropperColor] = useState('#fff');
  const [color, setColor] = useState('#fff'); // 默认颜色值
  const colors = ['#FF8888', '#19164E', '#F7FF1B', '#FF2A05', '#D9D9D9'];

  useEffect(() => {
    setSizeValue(size);
    setTimeout(() => {
      adjustBrushSize(sendMessage, size);
    }, 100);
  }, [size]);

  useEffect(() => {}, []);
  const startPickColor = async () => {
    if ('EyeDropper' in window) {
      const eyeDropper = new EyeDropper();
      try {
        const result = await eyeDropper.open();
        setEyeDropperColor(result.sRGBHex);
        onColorChange(result.sRGBHex);
        setColor(result.sRGBHex);
        // document.getElementById('pickedColor').textContent = result.sRGBHex;
        // document.getElementById('pickedColor').style.backgroundColor = result.sRGBHex;
      } catch (err) {
        console.error('用户取消或不支持：', err);
      }
    } else {
      info('你的浏览器不支持 EyeDropper API，建议更换成Chrome浏览器');
      // alert('你的浏览器不支持 EyeDropper API');
    }
  };
  return (
    <div
      className="color-and-pen-picker"
      onClick={(event) => {
        event.stopPropagation();
        event.preventDefault();
      }}>
      {showColor && (
        <div className="color-header">
          <div className="xi-pen" onClick={startPickColor}></div>
          <div className="color-result" style={{ backgroundColor: eyeDropperColor }}></div>
        </div>
      )}
      {showColor && (
        <ColorPicker
          value={color}
          onChange={(v) => {
            setColor(v);
            onColorChange(v);
            setEyeDropperColor(v);
          }}
          style={{ backgroundColor: '#222', background: 'none', width: '100%' }}></ColorPicker>
      )}
      <div className="slider-row">
        <div className="title">Brush Size</div>
        <Slider
          min={0}
          max={1}
          value={sizeValue}
          style={{ flex: 1 }}
          step={0.1}
          onChange={(value) => {
            onSizeChange(value);
            setSizeValue(value);
          }}></Slider>
      </div>
      {showColor && (
        <div className="colors">
          {colors.map((color) => {
            return (
              <div
                key={color}
                className="color-item"
                style={{ backgroundColor: color }}
                onClick={() => {
                  setColor(color);
                  onColorChange(color);
                  setEyeDropperColor(color);
                }}></div>
            );
          })}
        </div>
      )}
    </div>
  );
}
